import { FC, ReactNode } from 'react';
import { Tooltip } from '../Tooltip';

type Props = {
  /** Что значок означает: и подсказка при наведении, и доступное имя */
  label: string;
  icon: ReactNode;
};

/**
 * Значок признака у строки списка — системный, совместный, закреплённый — с подписью в подсказке.
 *
 * Значок не кнопка: он ничего не делает, но без подписи опознаётся только чтением с экрана. Подпись
 * задаётся один раз и служит и подсказкой, и доступным именем — как у `IconButton`, — а вид
 * признака у всех списков общий и правится в одном месте.
 */
export const LabeledIcon: FC<Props> = ({ label, icon }) => (
  <Tooltip tooltip={label}>
    <span aria-label={label} className="shrink-0 text-muted-foreground">
      {icon}
    </span>
  </Tooltip>
);
